<template>
  <div>
    <hr />
    <div class="mb-3">
      <table class="tablaBusqueda">
        <tr>
          <td>
            <button
              type="submit"
              class="btn btn-light"
              data-bs-toggle="modal"
              data-bs-target="#ventanaModal"
              @click="abrirModalCrear"
              title="Nuevo registro"
            >
              <i
                class="material-icons"
                style="font-size: 24px; color: green; cursor: pointer"
                >add_box</i
              >
            </button>
          </td>
        </tr>
      </table>
    </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">Medio</th>
          <th scope="col">Descripción</th>
          <th scope="col">Fecha de registro</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="medioemp in datosPaginados" :key="medioemp.idMedioEmp">
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: orangered; cursor: pointer"
              @click="abrirModalEditar(medioemp.idMedioEmp)"
              title="Editar"
              >edit_square</i
            >
          </td>
          <td>{{ medioemp.medioComNombre }}</td>
          <td>{{ medioemp.descripcion }}</td>
          <td>{{ medioemp.fechaReg }}</td>
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: red; cursor: pointer"
              @click="deleteMedioEmp(medioemp.idMedioEmp)"
              title="Borrar"
              >delete</i
            >
          </td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()">
          <a class="page-link" href="#">Anterior</a>
        </li>
        <li
          id="lugar"
          v-for="pagina in totalPaginas()"
          v-bind:key="pagina"
          v-on:click="getDataPaginaTodos(pagina)"
          class="page-item"
          v-bind:class="isActive(pagina)"
        >
          <a class="page-link" href="#">{{ pagina }}</a>
        </li>
        <li class="page-item" v-on:click="getNextPage()">
          <a class="page-link" href="#">Siguiente</a>
        </li>
      </ul>
    </nav>
    <!-- Modal -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title" id="exampleModalLabel">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2">
                    <label for="idMedioEmp" class="form-label"
                      >IdMedioEmp</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="idMedioEmp"
                      name="idMedioEmp"
                      v-model="datoMedioEmp.idMedioEmp"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <!-- Botón Lista de Valores  Medio Com -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idMedioCom" class="form-label">
                      Medio Com</label
                    >
                  </div>
                  <div class="col-10">
                    <select
                      class="form-control"
                      id="idMedioCom"
                      name="idMedioCom"
                      v-model="datoMedioEmp.idMedioCom"
                    >
                      <option
                        v-for="medioCom in medioComs"
                        :value="medioCom.idMedioCom"
                        :key="medioCom.idMedioCom"
                      >
                        {{ medioCom.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Botón Lista de Valores  Medio Com -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="descripcion" class="form-label"
                      >Descripción</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="descripcion"
                      name="descripcion"
                      v-model="datoMedioEmp.descripcion"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="fechaReg" class="form-label"
                      >Fecha de registro</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="fechaReg"
                      name="fechaReg"
                      v-model="datoMedioEmp.fechaReg"
                      disabled
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <!--
            <div class="me-auto">
              <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
                <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
              </button>
            </div>
-->
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="guardarMedioEmp"
              v-if="btnCrear"
              title="Guardar"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
                >save</i
              >Guardar
            </button>
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="actualizarMedioEmp"
              v-if="btnEditar"
              title="Actualizar"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
                >update</i
              >Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import config from '@/config';
import api from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";
import dateFormat from "@/modules/dateFormat.js";


import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;
import swal from "sweetalert";
export default {
  props: {
    p_idEmpresa: {
      type: Number,
      required: true,
    },
  },
  components: {},
  data() {
    return {
      medioemps: [],
      datoMedioEmp: {},
      nombreBusqueda: "",
      titulo: "",
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      medioComs: [],
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px",
      },
    };
  },
  mounted() {
    this.getDataPaginaTodos(this.paginaActual);
    this.fetchMedioComs();
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas() {
      return Math.ceil(this.medioemps.length / this.elementosPorPagina);
    },
    getDataPaginaTodos(noPagina) {
      api.get("/vwmedioemps/idempresa/" +
            this.p_idEmpresa
        )
        .then((response) => {
          this.medioemps = response.data.reverse();
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini =
            noPagina * this.elementosPorPagina - this.elementosPorPagina;
          let fin = noPagina * this.elementosPorPagina;
          this.datosPaginados = this.medioemps.slice(ini, fin);
        });
    },
    getPreviousPage() {
      if (this.paginaActual > 1) {
        this.paginaActual--;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) {
        this.paginaActual++;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    isActive(noPagina) {
      return noPagina == this.paginaActual ? "active" : "";
    },
    validarForm() {
      const requiredFields = ["idMedioCom", "descripcion"];
      const requiredFieldsText = ["idMedioCom", "idEmpresa", "descripcion"];
      return validarForm(this.datoMedioEmp, requiredFields, requiredFieldsText);
    },
    async guardarMedioEmp() {
      if (this.validarForm() === 1) {
        try {
          this.datoMedioEmp.idEmpresa =
            window.sessionStorage.getItem("idEmpresa");
          await api.post("/medioemps",
            this.datoMedioEmp
          );
          $("#ventanaModal").modal("hide");
          swal("Correcto!", "MedioEmp creada exitosamente!", "success");
          this.getDataPaginaTodos(this.paginaActual);
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async actualizarMedioEmp() {
      if (this.validarForm() === 1) {
        try {
          await api.post("/medioemps",
            this.datoMedioEmp
          );
          $("#ventanaModal").modal("hide");
          this.getDataPaginaTodos(this.paginaActual);
          swal("Correcto!", "MedioEmp creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors);
          array.forEach((element) => swal(String(element)));
        }
      }
    },
    abrirModalCrear() {
      this.modalWindow = true;
      this.datoMedioEmp = {};
      this.titulo = "Crear Empresa: Medios de Comunicación";
      this.btnCrear = true;
      this.btnEditar = false;
    },
    abrirModalEditar(idMedioEmp) {
      this.modalWindow = true;
      if (idMedioEmp != null) {
        api.get("/vwmedioemps/" + idMedioEmp)
          .then((resp) => {
            this.datoMedioEmp = resp.data;
          });
      }
      $("#ventanaModal").modal("show");
      this.titulo = "Editar Empresa: Medios de Comunicación";
      this.btnCrear = false;
      this.btnEditar = true;
    },
    async deleteMedioEmp(idMedioEmp) {
      try {
        await api.delete("/medioemps/" + idMedioEmp
        );
        this.getDataPaginaTodos(this.paginaActual);
      } catch (error) {
        alert("No se pudo eliminar");
      }
    },
    fetchMedioComs() {
      fetch(config.apiBaseUrl + "/vwmediocoms")
        .then((response) => response.json())
        .then((data) => {
          this.medioComs = data;
        })
        .catch((error) => {
          console.error("Error fetching medioComs:", error);
        });
    },
  },
};
</script>
